import { render, staticRenderFns } from "./question-form.vue?vue&type=template&id=5d3051d6"
import script from "./question-form.vue?vue&type=script&lang=js"
export * from "./question-form.vue?vue&type=script&lang=js"
import style0 from "./question-form.vue?vue&type=style&index=0&id=5d3051d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports